import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import axios from "axios";
import bcrypt from 'bcryptjs'; // bcryptjs를 통해 비밀번호 해싱
import "../styles/MySetup.css"; // 스타일 적용
import AddLog from "./AddLog"; // ✅ 로그 저장 함수 가져오기

import { FaEdit } from "react-icons/fa"; // 수정 아이콘 추가

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const MySetup = () => {
    const navigate = useNavigate(); // 페이지 이동을 위한 훅
    const { user, setUser } = useAuth();
    //const [isEditPopupOpen, setEditPopupOpen] = useState(false);
    const [isPasswordPopupOpen, setPasswordPopupOpen] = useState(false);
    const [editField, setEditField] = useState(null);
    const [editValue, setEditValue] = useState("");
    // 초기 전화번호 분할
    const [phone1, setPhone1] = useState("");
    const [phone2, setPhone2] = useState("");
    const [phone3, setPhone3] = useState("");
    // 초기 이메일 분할
    const [email1, setEmail1] = useState("");
    const [email2, setEmail2] = useState("");

    // 비밀번호 변경을 위한 상태
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmNewPassword, setConfirmNewPassword] = useState("");
    //const [error, setError] = useState(""); // 에러 메시지

    /*
    useEffect(() => {
        // editField가 "전화번호"일 때와 "이메일"일 때 상태 업데이트
        if (editField === "전화번호") {
            setEditValue({ part1: "", part2: "", part3: "" });
        } else if (editField === "이메일") {
            setEditValue({ local: "", domain: "" });
        } else {
            setEditValue(""); // 그 외의 경우에는 빈 값으로 초기화
        }
    }, [editField]); // editField가 변경될 때마다 실행
    */

    if (!user) {
        return <div className="mysetup-wrapper"><div className="mysetup-container">로그인 정보가 없습니다.</div></div>;
    }


    const formatValue = (field, value) => {
        if (field === "전화번호") {
            return `${phone1}-${phone2}-${phone3}`;
        } else if (field === "이메일") {
            return `${email1}@${email2}`;
        }
        return value; // 일반 텍스트 값 그대로 반환
    };

    // 수정 버튼 클릭 시 팝업 열기
    const handleEditClick = (field, value) => {
        
        if (field === "전화번호" && value) {
            const phoneParts = value.split("-");
            setPhone1(phoneParts[0] || "");
            setPhone2(phoneParts[1] || "");
            setPhone3(phoneParts[2] || "");

            //alert(phoneParts[0]);
        } else if (field === "이메일" && value) {
            const emailParts = value.split("@");
            setEmail1(emailParts[0] || ""); // @ 앞부분
            setEmail2(emailParts[1] || ""); // @ 뒷부분
            
        } 
        else if (field === "주소1") {
            handleAddressSearch(); // 주소1은 팝업 없이 바로 주소 검색
            return;
        }
        else {
            setEditValue(value || ""); // 기본 문자열 값 처리
        }
        setEditField(field);
        setEditValue(value);
    };

    


    // 카카오 주소 검색
    const handleAddressSearch = () => {
        new window.daum.Postcode({
            oncomplete: (data) => {
                // 주소를 DB에 저장
                saveChanges("주소1", data.address);                
            },
            width: 500, // 창 너비
            height: 600, // 창 높이
        }).open({
            left: (window.screen.width / 2) - 250,  // 중앙 정렬 (화면 너비 기준)
            top: (window.screen.height / 2) - 300   // 중앙 정렬 (화면 높이 기준)
        });
    };
    
    // 팝업 닫기
    //const closePopup = () => {
    //    setEditField(null);
    //    setEditValue("");
    //};

    // 변경 사항 저장
    const saveChanges = async (field, value) => {
        const trimmedValue = value.trim();
        
        if (field === "전화번호") {
            const trimmedP1 = phone1.trim();
            const trimmedP2 = phone2.trim();
            const trimmedP3 = phone3.trim();
            if (!trimmedP1 || !trimmedP2 || !trimmedP3) {
                alert(`올바른 전화번호를 입력해주세요.`);
                return;
            }            
        }
        else if (field === "이메일") {
            const trimmedE1 = email1.trim();
            const trimmedE2 = email2.trim();
            if (!trimmedE1 || !trimmedE2) {
                alert(`올바른 이메일 주소를 입력해주세요.`);
                return;
            }            
        }
        else if (!trimmedValue) {
            alert(`${field}을(를) 입력해주세요.`);
            return;
        }

        
        try {
            const response = await axios.post(`${API_BASE_URL}/api/Account/update-field`, {
                userId: user.userId,
                fieldName: field,
                newValue: trimmedValue,
            });

            if (response.status === 200) {

                await AddLog(user.userId, "", field, "8-2");

                alert("변경이 완료되었습니다.");

                // user 객체를 새로운 객체로 업데이트해야 상태가 변경됨
                setUser((prevUser) => ({
                    ...prevUser,
                    [field === "이름" ? "name" : field === "전화번호" ? "phone" : field === "이메일" ? "email" : field === "주소1" ? "address1" : field === "주소2" ? "address2" : field]: trimmedValue
                }));
                
                setEditField(null);
                setEditValue("");
            } else {
                alert("저장 실패");
            }
        } catch (error) {
            console.error("저장 중 오류 발생:", error);
            alert("저장 실패");
        }
    };


    // 비밀번호 변경 처리 함수
    const handlePasswordChange = async () => {

        if (currentPassword.length < 1) {
            alert("현재 비밀번호를 입력해주세요.");
            return;
        }


        if (newPassword.length < 1) {
            alert("새 비밀번호를 입력해주세요.");
            return;
        }

        if (confirmNewPassword.length < 1) {
            alert("새 비밀번호 확인을 입력해주세요.");
            return;
        }

        if (!user.userPW) {
            alert("비밀번호 정보를 불러올 수 없습니다.");
            return;
        }

        // 현재 비밀번호가 올바른지 확인
        const isPasswordCorrect = bcrypt.compareSync(currentPassword, user.userPW);
        if (!isPasswordCorrect) {
            alert("현재 비밀번호가 일치하지 않습니다.");
            return;
        }

        // 새 비밀번호와 확인 비밀번호가 일치하지 않으면
        if (newPassword !== confirmNewPassword) {
            alert("새 비밀번호와 확인 비밀번호가 일치하지 않습니다.");
            return;
        }

        // 새 비밀번호가 유효하면 (예: 6자 이상)
        if (newPassword.length < 6) {
            alert("새 비밀번호는 6자 이상이어야 합니다.");
            return;
        }

        // 비밀번호가 모두 올바르면 bcrypt로 해싱
        const hashedPassword = bcrypt.hashSync(newPassword, 10);

        // 여기서 DB에 업데이트하는 API 호출 등 처리
        try {
            const response = await axios.post(`${API_BASE_URL}/api/Account/change-password`, {
                userId: user.userId,  // 로그인한 사용자 ID
                currentPassword: currentPassword,
                newPassword: newPassword,
            });

            if (response.status === 200) {
                // 서버에서 암호화된 비밀번호를 반환하면 user.userPW 업데이트
                //user.userPW = response.data.hashedPassword;

                await AddLog(user.userId, "", "", "8-3");

                user.userPW = hashedPassword;                
                alert("비밀번호 변경 완료!");
                closePopupPW();
            } else {
                alert(response.data.message);
            }
        } catch (error) {
            console.error("비밀번호 변경 중 오류 발생:", error);
            alert("비밀번호 변경 실패");
        }


        //console.log("새 비밀번호:", hashedPassword);
        setPasswordPopupOpen(false); // 팝업 닫기
        //alert(""); // 에러 메시지 초기화
        //alert("비밀번호가 성공적으로 변경되었습니다.");
    };

    const closePopupPW = () => {
        setCurrentPassword("");
        setNewPassword("");
        setConfirmNewPassword("");
        setPasswordPopupOpen(false);
    };

    

    return (
        <div className="mysetup-wrapper">
            <div className="mysetup-container">
                <h1>
                    내 설정
                    <button onClick={() => setPasswordPopupOpen(true)}>비밀번호 변경</button>
                </h1>
                <ul className="user-info">
                    <li><span className="title2">사용자 ID</span> <span className="value">{user?.userId}</span></li>
                    <li><span className="title2">등록일자</span> <span className="value">{user?.userDate}</span></li>
                    {user?.userType === "S" && (
                        <>
                            
                            <li>
                                <span className="title2">회원 구분</span>
                                <span className="value">
                                    {{
                                        S: "빛담관리자",
                                        P: "협력사",
                                        G: "관공서",
                                        U: "사용자"
                                    }[user?.userType] || user?.userType}
                                </span>
                            </li>
                        </>
                    )}
                    <li>
                        <span className="title2">이름</span>
                        <span className="value">{user?.name}</span>
                        <FaEdit className="edit-icon" onClick={() => handleEditClick("이름", user?.name)} />
                    </li>
                    <li>
                        <span className="title2">전화번호</span>
                        <span className="value">{user?.phone}</span>
                        <FaEdit className="edit-icon" onClick={() => handleEditClick("전화번호", user?.phone)} />
                    </li>
                    <li>
                        <span className="title2">이메일</span>
                        <span className="value">{user?.email}</span>
                        <FaEdit className="edit-icon" onClick={() => handleEditClick("이메일", user?.email)} />                        
                    </li>
                    <li>
                        <span className="title2">주소1</span>
                        <span className="value">{user?.address1 || "-"}</span>
                        <FaEdit className="edit-icon" onClick={() => handleEditClick("주소1", user?.address1)} />
                    </li>
                    <li>
                        <span className="title2">주소2</span>
                        <span className="value">{user?.address2 || "-"}</span>
                        <FaEdit className="edit-icon" onClick={() => handleEditClick("주소2", user?.address2)} />
                    </li>
                    {/*
                    {user?.userType === "S" && (
                        <>
                            <li><span className="title">활성화 상태</span> <span className="value">{user?.isActive === "T" ? "활성화됨" : "비활성화됨"}</span></li>
                        </>
                    )}
                    */}
                </ul>

                                   
                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px", marginRight: "20px" }}>
                    <button onClick={() => navigate("/LogInsert")}>
                        로그정보 보기
                    </button>
                </div>
                

                {/*
                <div className="button-container">
                    <button onClick={() => setPasswordPopupOpen(true)}>비밀번호 변경</button>
                </div>
                */}
                {/* 수정 팝업 */}
                {editField && (
                    <div className="popup">
                        <button className="close-btn" onClick={() => setEditField(null)}>✖</button>
                        <div className="popup-content">
                            <h2>{editField} 수정</h2>
                            {editField === "전화번호" ? (
                                < div className="phone-inputs">
                                    <input
                                        type="text"
                                        value={phone1}
                                        onChange={(e) => {
                                            // 숫자만 입력되도록 필터링
                                            const newPhone1 = e.target.value.replace(/[^0-9]/g, '');
                                            setPhone1(newPhone1);
                                            setEditValue(`${e.target.value}-${phone2}-${phone3}`);
                                        }}
                                        maxLength={3}
                                        //placeholder="010"
                                    />
                                    <span>-</span>
                                    <input
                                        type="text"
                                        value={phone2}
                                        onChange={(e) => {
                                            // 숫자만 입력되도록 필터링
                                            const newPhone2 = e.target.value.replace(/[^0-9]/g, '');
                                            setPhone2(newPhone2);
                                            setEditValue(`${phone1}-${e.target.value}-${phone3}`);
                                        }}
                                        maxLength={4}
                                        //placeholder="1234"
                                    />
                                    <span>-</span>
                                    <input
                                        type="text"
                                        value={phone3}
                                        onChange={(e) => {
                                            // 숫자만 입력되도록 필터링
                                            const newPhone3 = e.target.value.replace(/[^0-9]/g, '');
                                            setPhone3(newPhone3);
                                            setEditValue(`${phone1}-${phone2}-${e.target.value}`);
                                        }}
                                        maxLength={4}
                                        //placeholder="5678"
                                    />
                                </div>
                            ) : editField === "이메일" ? (
                                <div className="email-inputs">
                                    <input
                                        type="text"
                                            value={email1}
                                            onChange={(e) => {
                                                setEmail1(e.target.value);
                                                setEditValue(`${e.target.value}@${email2}`);
                                            }}
                                        maxLength={20}
                                        //placeholder="example"
                                    />
                                    <span>@</span>
                                    <input
                                            type="text"
                                            value={email2}
                                            onChange={(e) => {
                                                setEmail2(e.target.value);
                                                setEditValue(`${email1}@${e.target.value}`);
                                            }}
                                        maxLength={19}
                                        //placeholder="domain.com"
                                    />
                                </div>
                            ) : (


                                <input
                                    type="text"
                                    value={editValue}
                                    onChange={(e) => setEditValue(e.target.value)}
                                    maxLength={editField === "이름" ? 18 :
                                        editField === "주소2" ? 40 :
                                            20
                                    }
                                />
                            )}

                            

                            
                            <div className="button-container">
                                <button className="confirm-btn" onClick={() => saveChanges(editField, formatValue(editField, editValue))}>저장</button>
                            </div>
                        </div>
                    </div>                 
                )}

                {/* 비밀번호 변경 팝업 */}
                {isPasswordPopupOpen && (
                    <div className="popup">
                        <button className="close-btn" onClick={closePopupPW}>✖</button> {/* 닫기 버튼 (X) */}
                        <div className="popup-content">
                            <h2>비밀번호 변경</h2>

                            <div>
                                <label>현재 비밀번호를 입력해주세요:</label>
                                <input
                                    type="password"
                                    value={currentPassword}
                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                    maxLength={20}
                                />
                            </div>

                            <div>
                                <label>새 비밀번호를 입력해주세요:</label>
                                <input
                                    type="password"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    maxLength={20}
                                />
                            </div>

                            <div>
                                <label>새 비밀번호를 다시 입력해주세요:</label>
                                <input
                                    type="password"
                                    value={confirmNewPassword}
                                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                                    maxLength={20}
                                />
                            </div>

                            <div className="button-container">
                                <button className="confirm-btn" onClick={handlePasswordChange}>확인</button>
                            </div>
                        </div>
                    </div>
                )}

            </div>
        </div>
    );
};

export default MySetup;
